import React, { useState } from "react";
import "./style.scss";
import Orders from "./orders";
import Address from "./address";
import Accountdetails from "./accountdetails";
import WishList from "./wishList";
import { useLogoutMutation } from "../../../services/myAccountAPI";
import { useGetColorThemeQuery } from '../../../services/commonAPI';

const VerticalTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [logout, { isLoading }] = useLogoutMutation();

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();
  const handleLogout = async () => {
    try {
      const response = await logout().unwrap();
      if (response.message === "Successfully logged out") {
        // Clear local storage/state
        localStorage.removeItem("access_token");
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");

        localStorage.removeItem("OrderId");
        localStorage.removeItem("OrderMainId");
        localStorage.removeItem("cart_id");

        localStorage.clear();
        // Redirect to login page
        window.location.replace("/login");
      }
    } catch (error) {
      console.error("Logout failed:", error);
      // Handle error (show toast/notification)
    }
  };

  const tabs = [
    { label: "Orders", content: <Orders /> },
    { label: "Address", content: <Address /> },
    { label: "Account Details", content: <Accountdetails /> },
    { label: "Wishlist", content: <WishList /> },
    {
      label: "Logout",
      content: (
        <div className="logout-container">
          <h2>Logout</h2>
          <button
            onClick={handleLogout}
            disabled={isLoading}
            className="logout-button"
          >
            {isLoading ? "Logging out..." : "Click here to logout"}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="my-account">
      <div className="container">
        <div className="vertical-tabs-container">
          <div className="tabs">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab ${index === activeTab ? "active" : ""}`}
                onClick={() => {
                  if (tab.label === "Logout") {
                    handleLogout();
                  } else {
                    setActiveTab(index);
                  }
                }}
                style={
                  index === activeTab
                    ? {
                      backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                      color: "white",
                    }
                    : {}
                }
              >
                {tab.label}
              </div>
            ))}
          </div>

          <div className="tab-content">{tabs[activeTab].content}</div>
        </div>
      </div>
    </div>
  );
};

export default VerticalTabs;
